import { Bold2, H3 } from '@uswitch/spark.type'
import React from 'react'

import * as st from '../styles'

export const Header = ({ heading, image, title }) => {
  return (
    <>
      <H3 sx={st.tableHeading}>{heading}</H3>
      <div sx={st.header}>
        {image && <img src={image.src} alt={image.alt} height={40} width={64} />}
        <Bold2 sx={st.tableHeading}>{title}</Bold2>
      </div>
    </>
  )
}
